export const api = '/api';
